export class UIMode {
	static SELECT = 'select'
	static VIEW_SELECTION = 'view-selection'
}

export const modes = [UIMode.SELECT, UIMode.VIEW_SELECTION]
